import { Spin } from 'antd'
import { useTranslation } from 'react-i18next'

import {
  ContainerTable,
  CustomHeaderTable,
  DataCellWrapper,
  HeaderCelDate,
  HeaderCellWrapper,
  TableCustom,
  TableWrapper,
  Wrappertable,
} from '@/components/pages/ClientDevice/styles'
import { GetWashingCountByRangeDayResponse } from '@/types/apis/washingCount'
import { formatYMD } from '@/utils/date'
import { formatJapaneseNumber } from '@/utils/formatPrice'

type Props = {
  responseWashingCountByRangeDay: GetWashingCountByRangeDayResponse
  responseWashingCountByRangeDayLoading?: boolean
}

const WashingCountByRangeDayTable = ({
  responseWashingCountByRangeDay,
  responseWashingCountByRangeDayLoading,
}: Props) => {
  const { t } = useTranslation()
  const dataSource = responseWashingCountByRangeDay

  return (
    <ContainerTable>
      <Spin spinning={responseWashingCountByRangeDayLoading}>
        <TableWrapper>
          <Wrappertable>
            <TableCustom>
              <tbody>
                <CustomHeaderTable>
                  <HeaderCelDate>{t('components.pages.clientDevice.listReport.table.date')}</HeaderCelDate>
                  {dataSource[0]?.items.map((washingCount, index) => (
                    <HeaderCellWrapper key={index}>{washingCount.name}</HeaderCellWrapper>
                  ))}

                  <HeaderCellWrapper>{t('components.pages.clientDevice.listReport.table.total')}</HeaderCellWrapper>
                </CustomHeaderTable>

                {dataSource.map((washingCount, index) => (
                  <tr key={index}>
                    <DataCellWrapper>{formatYMD(washingCount.date)}</DataCellWrapper>
                    {washingCount.items.map((item, index) => (
                      <DataCellWrapper key={index}>{item.count ? formatJapaneseNumber(item.count) : 0}</DataCellWrapper>
                    ))}
                    <DataCellWrapper>
                      {washingCount?.totalCount ? formatJapaneseNumber(washingCount.totalCount) : 0}
                    </DataCellWrapper>
                  </tr>
                ))}
              </tbody>
            </TableCustom>
          </Wrappertable>
        </TableWrapper>
      </Spin>
    </ContainerTable>
  )
}
WashingCountByRangeDayTable.displayName = 'WashingCountByRangeDayTable'
export default WashingCountByRangeDayTable
